import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Why Us Grid - staggered fade in from bottom
 */
export const animateWhyUsGrid = (ref) => {
  if (ref.current) {
    // Set initial state immediately to prevent flash
    const gridElement = ref.current.querySelector('[class*="grid"]');
    if (gridElement) {
      const items = gridElement.querySelectorAll('[class*="gridItem"]');
      if (items.length > 0) {
        gsap.set(items, { opacity: 0, y: 60 });
      }
    }
    
    const timer = setTimeout(() => {
      if (gridElement) {
        const items = gridElement.querySelectorAll('[class*="gridItem"]');
        if (items.length > 0) {
          gsap.to(items, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.15,
            ease: "power2.out",
            scrollTrigger: {
              trigger: ref.current,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
          ScrollTrigger.refresh();
        }
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

